module.exports = __webpack_public_path__ + "static/media/any-startup-idea.18e55ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/any-startup-idea.svg
// module id = 177
// module chunks = 0